export async function getCurrentTime(distribution) {
    return fetch(process.env.REACT_APP_API_SERVER+"/message/target/"+distribution).then((res)=>{
        const time = res.headers.get('time');
        return time;
    })
}